module.exports = {
  label: {
    headerTitle: 'Device Management',
    addHeaderTitle: 'Add Device Management',
    editHeaderTitle: 'Edit Device Management',
    selectSite: 'Select Site',
    siteName: 'Site',
    deviceName: 'Device Name',    
    deviceIdentifier: 'Device Identifier',
    search: 'Search...',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel'
    }
  }
}